import { useEffect, useState } from "react";
import { subscribeAudioReadiness, unlockAudio } from "@/lib/notificationSound";

/**
 * React hook wrapping the singleton audio-readiness pub/sub.
 *
 * Returns `{ blocked, unlock }`:
 *   - `blocked` — true while the browser is refusing to play audio because
 *     the tab has not yet received a user gesture (or the singleton context
 *     doesn't exist yet).
 *   - `unlock` — call inside a user-gesture handler to resume the shared
 *     AudioContext. Idempotent.
 *
 * Kept tiny on purpose — it exists so components don't reach into the
 * singleton directly.
 */
export function useAudioReadiness() {
    const [blocked, setBlocked] = useState(true);
    useEffect(() => subscribeAudioReadiness(setBlocked), []);
    return { blocked, unlock: unlockAudio };
}
